var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('BaseInventory',{attrs:{"categoryId":"7","categoryName":"Motor","categorySectionIcon":"fa-wrench","useSearch1":true,"search1Title":"Spek"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }